import React, { useState, useEffect } from "react"


import { Container, CardBody, Card } from "reactstrap"
import Breadcrumb from "components/Common/Breadcrumb"

import moment from "moment"
import { axiosbaseurl } from "configure"
import Loader from "components/Common/Loader"
import InvoicesList from "pages/Invoices/InvoicesList"
import { useClientContext } from "../ClientContextBox"
import ClientNotes from "./ClientNotes"

const ClientInvoices = ({ client_id }) => {

    const [table_data, settable_data] = useState([])
    const [loading, setLoading] = useState(false)

    const { clientCode } = useClientContext()

    useEffect(() => {
        const getInvoices = async () => {
            try {
                // setLoading(true)
                const response = await axiosbaseurl.get(`/xero/invoices/client/${clientCode}`);
                if (response.data.success) {
                    settable_data(response.data.data?.map(item => ({
                        invoiceID: item.invoiceID,
                        type: item.type,
                        clientName: item.contact?.name,
                        invoiceNumber: item.invoiceNumber,
                        currencyCode: item.currencyCode,
                        date: moment(item.date).format("DD MMMM, YYYY"),
                        dueDate: moment(item.dueDate).format("DD MMMM, YYYY"),
                        subTotal: item.subTotal,
                        totalTax: item.totalTax,
                        total: item.total,
                        isDiscounted: item.isDiscounted,
                        status: item.status,
                        amountDue: item.amountDue,
                        amountPaid: item.amountPaid,
                        amountCredited: item.amountCredited,
                    })))
                }
            } catch (error) {
                console.log(error)
            } 
            // finally {
            //     setLoading(false)
            // }
        }
        getInvoices()
    }, [])

    return (
        <>
            {loading && <Loader />}

            <Card className="px-0 mx-0">
                <CardBody >
                    <InvoicesList table_data={table_data} />
                </CardBody>
            </Card>

            <ClientNotes
                client_id={client_id}
                heading={"Note"}
                type={3}
            />
        </>
    )
}

export default ClientInvoices
